export const EyeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
      <path
        d="M0.599998 5.93331C0.599998 5.93331 3.26666 0.599976 7.93333 0.599976C12.6 0.599976 15.2667 5.93331 15.2667 5.93331C15.2667 5.93331 12.6 11.2666 7.93333 11.2666C3.26666 11.2666 0.599998 5.93331 0.599998 5.93331Z"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.93333 7.93331C9.0379 7.93331 9.93333 7.03788 9.93333 5.93331C9.93333 4.82874 9.0379 3.93331 7.93333 3.93331C6.82876 3.93331 5.93333 4.82874 5.93333 5.93331C5.93333 7.03788 6.82876 7.93331 7.93333 7.93331Z"
        stroke="currentColor"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
